import { Typography } from "../../../typography/Typography.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultStartContent = ({
  data: {
    text
  }
}) => {
  return /*#__PURE__*/_jsx(Typography, {
    variant: "strong",
    title: text,
    children: text
  });
};